
<template>
    <v-container fluid>
    <v-card elevation="0" flat tile>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="6">
                        <p class="text-h5">Images</p>
                        </v-col>
                        <v-col md="6" align=right>
                            <v-btn
                            class="button-shadow mr-1"
                            color="secondary"
                            @click="isAddImage = true"
                            >
                            Add
                            </v-btn>
                            <v-btn
                                class="button-shadow mr-1"
                                :to="`/${route}/list`"
                                replace
                                color="primary"
                            >
                                Done
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-data-table
                sort-by="imagerank"
                :headers="header_images"
                :items="data_images"
                :items-per-page="500"
                :footer-props="footer"
                :loading="isReceiving"
                class="elevation-0"
            >
                <template v-slot:top>
                    <v-dialog v-model="isDeleteImage" width="500">
                        <v-card>
                            <v-card-title> Delete this Image? </v-card-title>
                            <v-card-text>
                            {{ delete_image.imagename }}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="isDeleteImage = false"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    color="secondary"
                                    class="button-shadow"
                                    @click="deleteImage(delete_image)"
                                    >Delete
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <template v-slot:item.imageurl="{ item }">
                    <v-img
                    v-if="item.imageurl" 
                    v-bind:src="item.imageurl"
                    max-height="80"
                    max-width="80"
                  ></v-img>
                </template>               
                <template v-slot:item.imagesize="{ item }">
                    {{ (item.imagesize/1000).toFixed(0) + " KB"  }}    
                </template>
                <template v-slot:item.createdAt="{ item }">
                    {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        icon
                        color="primary"
                        @click="editImageDialog(item)"
                        >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="primary"
                        @click="deleteImageDialog(item)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <div>
        <v-dialog
            v-model="isAddImage"
            persistent
            width="1000px"
            max-width="1000px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Add Image</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="1">
                            <v-text-field
                                v-model="add_image.imagerank"
                                class="mb-4"
                                placeholder="Num"
                                type="number"
                                oninput="if(this.value < 0) this.value = 0;"
                                single-line
                                hint="Num"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                            v-model="add_image.imagename"
                            label="Image Name"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-file-input label="Image input" v-on:change="onChangeUploadFile" accept=".jpg" />
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isAddImage=false; add_image={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="addImage"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="isEditImage"
            persistent
            width="1000px"
            max-width="1000px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Edit Image</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="1">
                            <v-text-field
                            v-model="edit_image.imagerank"
                            v-on:change="onChangeImage($event, 'imagerank')"
                            class="mb-4"
                            placeholder="Num"
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Num"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                            v-model="edit_image.imagename"
                            v-on:change="onChangeImage($event, 'imagename')"
                            label="Image Name"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-file-input label="File input" v-model="edit_imagefile" v-on:change="onChangeUploadFileEdit" accept="image/*" />
                        </v-col>

                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isEditImage=false; edit_image={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="editImage"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    components: {

    },
    props: {
        images: {
            type: Array
        },
        id: String,
        route: String,
    },
    computed: {
        ...mapState('Image', ['isReceiving']),
    },
    data () {
        return {
            header_images: [
                { text: "#", value: "imagerank", width: "10px" },
                { text: "Image", value: "imageurl", width: "8%" },
                { text: "Name", value: "imagename" },
                { text: "Size", value: "imagesize", width: "10%" },
                { text: "Created", value: "createdAt", width: "10%" },
                { text: "Actions", value: "actions", sortable: false, width: "10%"  },
            ],
            data_images: [],
            edit_imagefile: null,
            isAddImage: false,
            isDeleteImage: false,
            isEditImage: false,
            add_image: {},
            delete_image: {},
            edit_image: {},
            change_image: {},
            footer: {'items-per-page-options': [500, 1000, 5000]},
        }
    },
    methods: {
        ...mapActions('Image', [ 'insertImageRequest', 'deleteImageRequest', 'updateImageRequest', 'updateImageWithImageRequest']),
        async addImage() {
            this.isAddImage = false;
            this.add_image.id = this.id;
            this.add_image.route = this.route;
            console.log(this.add_image)
            let result = await this.insertImageRequest(this.add_image);
            if(result!=null) this.data_images.splice(0,0,result);
            this.add_image = {};
        },
        deleteImageDialog(item) {
            this.isDeleteImage = true;
            this.delete_image = { _id: item._id, imagename: item.imagename };
        },
        async deleteImage(item) {
            this.isDeleteImage = false;
            let result = await this.deleteImageRequest(item);
            let index = this.data_images.findIndex((i) => i._id == result._id);
            this.data_images.splice(index, 1);
        },
        editImageDialog(item) {
            this.isEditImage = true;
            this.edit_image = Object.assign({},item);
        },
        async editImage() {
            this.isEditImage = false;
            let result;
            this.change_image.id = this.edit_image._id;
            if(this.change_image.imagefile!=null) result = await this.updateImageWithImageRequest(this.change_image);
            else result = await this.updateImageRequest(this.change_image);
            let index = this.data_images.findIndex((i)=> i._id == result._id);
            this.data_images.splice(index, 1, result);
        },
        onChangeImage(value, field){
            this.change_image[field] = value;
        },
        onChangeUploadFile(image) {
            if (!image) this.add_image.imagefile = null;
            else this.add_image.imagefile = image;
        },
        onChangeUploadFileEdit(image) {
            if (!image) this.change_image.imagefile = null;
            else this.change_image.imagefile = image;
        },
    },
    created(){
        this.data_images = Object.assign([], this.images);
    }
}
</script>